import { type FC } from "react"
import { Navigate, useParams } from "react-router"

import Error from "~/components/error"
import Layout from "~/components/layout"
import Loader from "~/components/loader"
import { query } from "~/utilities/trpc"

import EditContent from "./edit-content"
import ViewContent from "./view-content"

const CoursePage: FC = () => {
	const courseId = useParams().courseId ?? ""

	const { data: course, error, refetch } = query.getCourse.useQuery(courseId)

	if (course === null) return <Navigate to="/courses" />

	return (
		<Layout>
			{error ? (
				<Error message="Det gick inte att ladda kursen. Försök igen senare." />
			) : course === undefined ? (
				<Loader label="Laddar kurs..." />
			) : course.status === "draft" || course.status === "change-requested" ? (
				<EditContent course={course} reload={refetch} />
			) : (
				<ViewContent course={course} />
			)}
		</Layout>
	)
}

export default CoursePage
